import { render } from "./ChainsList.vue?vue&type=template&id=055e981e&scoped=true"
import script from "./ChainsList.vue?vue&type=script&lang=js"
export * from "./ChainsList.vue?vue&type=script&lang=js"

import "./ChainsList.vue?vue&type=style&index=0&id=055e981e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-055e981e"]])

export default __exports__